import $ from 'jquery';
import { gsap } from 'gsap';
import Function from './_Function.js';
import Op from '../Window/_OpResize.js';
import Hebi from '../Window/_HebiResize.js';
import Text from '../Window/_TextResize.js';
// import TextHHResize from '../Window/_TextHHResize.js';
import MainContent from '../Window/_MainContentResize.js';
import { ManagePage } from '../Manage/_ManagePage.js';

export default class WindowResize {
  constructor () {
    const op = new Op();
    const hebi = new Hebi();
    const text = new Text();
    // const textHH = new TextHHResize();
    const mainContent = new MainContent();
    // const main = new Main();
    const breakpoint = window.matchMedia('(max-width:768px)');
    let resizeTimer = false;

    /*

    初回ロード時

    */

    // $(window).on('load', function () {
    op.setOpScale();
    // main.setScale();
    hebi.setHebiScale();
    text.setTextScale();
    // textHH.setTextSpScale();
    mainContent.setMainContentHeight();
    // text.setTxtHHScale();
    // });

    /*

      ウィンドウリサイズ

    */

    $(window).resize(function () {
      if (resizeTimer !== false) {
        clearTimeout(resizeTimer);
      }
      resizeTimer = setTimeout(function () {
        op.setOpScale();
        hebi.setHebiScale();
        text.setTextScale();
        // textHH.setTextSpScale();
        mainContent.setMainContentHeight();
      }, 200);
    });

    /*

      ブレークポイントを通過したら

    */
    breakpoint.addEventListener('change', () => {
      // console.log("🚀 ~ breakpoint.addEventListener ~ breakpoint:", breakpoint)
      ManagePage.setPage(ManagePage.getCurrentPageNum());
    });
  }
}

// (() => {})();
